






































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































// @ is an alias to /src
import { Component, Emit, Vue } from "vue-property-decorator";
import Navbar from "@/components/Navbar.vue";
import ModelSelector from "@/components/modelSelector.vue";
import VesionsCarsCards from "@/components/versionesAutos.vue";
import Formulario from "@/components/Formulario.vue";
import info from "@/info";

@Component({
  components: {
    Navbar,
    ModelSelector,
    VesionsCarsCards,
    Formulario,
  },
})
export default class SCross extends Vue {
  @Emit()
  openModalDetalle(
    auto: string,
    titulo: string,
    interes: string,
    version: string
  ) {
    return {
      auto: auto,
      titulo: titulo,
      interes: interes,
      version: version,
    };
  }

  openModelSelector(): void {
    let curtainForm = document.getElementById("curtain-formM");
    let menuForm = document.getElementById("menu-formM");

    if (curtainForm) {
      curtainForm.style.display = "block";
    }
    menuForm?.classList.remove("disable-menu-formM");
    menuForm?.classList.add("open-menu-formM");
  }

  openPurebaManejoTw() {
    document.getElementById("PMtiket")!.click();
  }

  expand: boolean = true;
  toggleExpand() {
    this.expand = !this.expand;
  }

  mounted() {
    let tiket = this.$route.query.variableName;
    this.$router.push({ query: { variableNavName: "S-CROSS" } });
    if (tiket == "1") {
      setTimeout(function () {
        document.getElementById("tiket")!.click();
      }, 1000);
    }
    if (tiket == "2") {
      setTimeout(function () {
        document.getElementById("PMtiket")!.click();
      }, 1000);
    }
  }

  public autoName: string = "";
  public aIndex: object = {};

  openMenuForm(autoN: string) {
    this.aIndex == null
      ? this.aIndex
      : (this.aIndex = info.home.headerSlider[0]);
    this.autoName = autoN;
    for (let i in info.home.headerSlider) {
      if (info.home.headerSlider[i].name === this.autoName) {
        this.aIndex = info.home.headerSlider[i];
      }
    }
    const idDivModel = document.getElementById("uk-navbar-dropdown-id-ml");
    const idDiv = document.getElementById("uk-navbar-dropdown-id");

    if (idDivModel) {
      idDivModel.style.display = "none";
    }
    if (idDiv) {
      idDiv.style.display = "none";
    }

    let curtainForm = document.getElementById("curtain-formP");
    let menuForm = document.getElementById("menu-formP");

    if (curtainForm) {
      curtainForm.style.display = "block";
    }
    menuForm?.classList.remove("disable-menu-form");
    menuForm?.classList.add("open-menu-form");
  }
  closeMenuForm() {
    let curtainForm = document.getElementById("curtain-formP");
    let menuForm = document.getElementById("menu-formP");

    if (curtainForm) {
      curtainForm.style.display = "none";
    }
    menuForm?.classList.remove("open-menu-form");
    menuForm?.classList.add("disable-menu-form");
  }
  scrollState(state: string) {
    const elem = document.getElementById("scrollBlock");
    elem!.style.overflow = state;
  }
}
